import React, { Component } from "react";
import { connect } from "react-redux";
import "./content.scss";
import searchIcon from "../../../assets/svg/searchBlue.svg";
import { Link } from "react-router-dom";
import { configure_progress, gettingStartedProgress } from "../../../actions/globalAction";
import Icon from "semantic-ui-react/dist/es/elements/Icon";
import profileImg from "../../../assets/profile.png";
import { Dimmer, Loader } from "semantic-ui-react";
class UpdateProfile extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {}

    configureProgress = () => {
        this.props.configure_progress("update_profile");
    };

    render() {
        return (
            <>
                <div className="gs_content">
                    <div className="left_content">
                        <div className="gs_header">
                            <Icon name="user" size="large" className="icon_content" color="#268af6" width="20px" height="20px" />
                            <span className="content_title">Update Profile</span>
                        </div>
                        <div className="text_content">
                            <p>{`You can update your profile details in this section.  This includes your name, your company name etc. `}</p>
                            <p>You can switch on or off the interactive help.</p>
                            <p>{`Some of the reports and other functionality use your time zone to work properly.  You can set your time zone in this section.`}</p>
                        </div>
                        <Link to="/profile">
                            <button className="gs_link" onClick={() => this.configureProgress()}>
                                Explore Profile
                            </button>
                        </Link>
                    </div>
                    <div className="right_content">
                        <div id="gs_loader">
                            <Dimmer inverted active>
                                <Loader size="big skiptranslate">Loading</Loader>
                            </Dimmer>
                        </div>
                        <iframe
                            width="320px"
                            height="200px"
                            src="https://www.youtube.com/embed/CgI_-MmYeBc"
                            title=""
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; gyroscope; picture-in-picture"
                            allowFullScreen
                            onLoad={() => (document.getElementById("gs_loader").style.display = "none")}
                            className="content_video"></iframe>
                        {/* <img className="content-img" src={profileImg} width="350px" height="200px" /> */}
                    </div>
                </div>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {};
};

const mapDispatchToProps = (dispatch) => {
    return {
        configure_progress: (field) => dispatch(configure_progress(field)),
        gettingStartedProgress: () => dispatch(gettingStartedProgress()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(UpdateProfile);
